import { TItem } from "@/components/SortableList/SortableList";
import { TableColumn } from "@/components/Table/Table";

/**
 * Maps the tracker table's column definitions to the persisted column-settings
 * items (`TItem[]`) — the default config used when none is stored yet or the
 * stored one no longer matches the current columns.
 */
export const buildTrackerColumnConfig = (tableColumns: TableColumn[]): TItem[] =>
	tableColumns.map((c, index) => ({
		uid: c.uid ?? "",
		id: +index + 1,
		show: typeof c.show !== "undefined" ? c.show : true,
		content: c.title,
		locked: !!c.locked || false,
		allowExclude: typeof c.allowExclude !== "undefined" ? c.allowExclude : true,
		custom: c.uid?.includes("custom-") || false,
		columnId: c.uid?.includes("custom-") ? +c.uid.split("-")[1] : undefined,
		moveable: c.moveable,
		hideable: c.hideable,
	}));
